import { useSyncExternalStore } from 'react';
import effectivePermissionsService from '@/core/permissions/effective-permissions-service';

export function useEffectivePermissions(): string[] {
  return useSyncExternalStore(
    effectivePermissionsService.subscribe,
    effectivePermissionsService.getEffectivePermissions,
  );
}
